var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as UserActions from '../../../store/actions/user.actions';
import * as ModalActions from '../../../store/actions/modal.actions';
// import * as ModalActions from '@ibe/store/actions/modal.actions';
import { INDRAAuthenticationService } from '@ibe.services/authentication.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_LANGUAGE, DEFAULT_MARKET, UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE, LOGIN_AUTENTICATION_TYPE_GOOGLE, SOCIAL_GOOGLE_KEY } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRALoginModalComponent = /** @class */ (function (_super) {
    __extends(INDRALoginModalComponent, _super);
    function INDRALoginModalComponent(modalService, fb, store, sidebarService, router, authenticationService, ibeAdminConfigService, storage, ibeAdminService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.fb = fb;
        _this.store = store;
        _this.sidebarService = sidebarService;
        _this.router = router;
        _this.authenticationService = authenticationService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.storage = storage;
        _this.ibeAdminService = ibeAdminService;
        _this.isAlive = true;
        _this.infoLoading = true;
        _this.userLoggedIn = false;
        _this.loginError = false;
        _this.loginErrorUsernameRelated = false;
        _this.loginErrorPasswordRelated = false;
        _this.loginData = {
            login: null,
            // username: null,
            password: null
        };
        _this.loading$ = _this.store.select(fromStore.getUserLoading);
        _this.logged_in$ = _this.store.select(fromStore.getLoggedIn);
        _this.user_info$ = _this.store.select(fromStore.getUserInfo);
        // isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
        _this.isCorporate = false;
        // label: string;
        _this.hideClose = false;
        _this.timeToThink_to_booking$ = _this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
        _this.isTTTBookingPayment = false;
        _this.account = '';
        _this.bookedTripDiscounts$ = _this.store.select(fromStore.getSelectedBookedTripDiscounts);
        _this.bookedTripDiscounts = [];
        _this.passwordIsHidden = true;
        _this.isSubmitted = false;
        _this.gapiSetup = false; // marks if the gapi library has been loaded
        _this.PassFilled = false;
        _this.UserFilled = false;
        _this.PassFocused = false;
        _this.UserFocused = false;
        _this.lottieConfig = {
            path: './assets/animations/show.json',
            renderer: 'svg',
            autoplay: false,
            loop: false
        };
        /* note: from post sprint 8 merge
        this.isCorporate$.pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.isCorporate = value;
                if (value === true) {
                    this.isCorporate = true;
                    this.label = 'Username';
                    if (this.isTTTBokingPayment) {
                        this.TAP_disableCloseModal();
                    } else {
                        this.TAP_enableCloseModal();
                    }
                } else {
                    this.isCorporate = false;
                    this.label = 'Email or Customer Number';
                }
            });
        */
        _this.messages = {
            userUnknown: '10078.TAP.F User unknown',
            invalidCredentials: '10078.TAP.F - Invalid username/password - Invalid attempts: ',
            invalidUsernameOrPassword: '1.1.LDAP - Invalid attempts: ',
            loginServiceUnavailable: 'Login service unavailable',
            emailMultipleClients: '10078.TAP.F - Too many clients for given email',
            costumerDataError: '700.TAP - Target Provider Error - CDH',
            accountLocked: '10078.TAP.F - Account Locked',
            tryLater: 'Something went wrong. Try again later',
            unauthorized: '401 Unauthorized'
        };
        _this.translatedMessagesKey = {
            userUnknown: 'header.login.error.userUnknown',
            invalidCredentials: 'header.login.error.invalidCredentials',
            loginServiceUnavailable: 'header.login.error.loginServiceUnavailable',
            emailMultipleClients: 'header.login.error.emailMultipleClients',
            accountLocked: 'header.login.error.accountLocked',
            costumerDataError: 'header.login.error.costumerDataError',
            tryLater: 'header.error.tryLater',
            invalidStatus: 'header.login.error.invalidStatus',
            unauthorized: 'header.login.error.unauthorized',
        };
        _this.translatedMessagesTitleKey = {
            userUnknown: 'header.login.error.userUnknown.title',
            invalidCredentials: 'header.login.error.invalidCredentials.title',
            loginServiceUnavailable: 'header.login.error.loginServiceUnavailable.title',
            emailMultipleClients: 'header.login.error.emailMultipleClients.title',
            accountLocked: 'header.login.error.accountLocked.title',
            costumerDataError: 'header.login.error.costumerDataError.title',
            tryLater: 'header.error.tryLater.title'
        };
        _this.timeToThink_to_booking$.pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.isTTTBookingPayment = true;
                _this.account = value['account'] ? value['account'] : '';
                /* note: from post-sprint 8 client code merge
                if (this.isCorporate) {
                    this.TAP_disableCloseModal();
                } else {
                    this.TAP_enableCloseModal();
                }
                */
            }
        });
        _this.bookedTripDiscounts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discounts) {
            _this.bookedTripDiscounts = Object.assign([], discounts);
        });
        if (_this.router.url.includes('/booking/payment')) {
            _this.isBookingPaymentPage = true;
        }
        return _this;
    }
    INDRALoginModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        /* note: from post-sprint 8 client code merge
        if (this.isCorporate == true) {
            this.form = this.fb.group({
                login: [''],
                username: [
                    this.account,
                    [
                        Validators.required,
                        Validators.pattern('^[a-z0-9_.]+$'),
                        Validators.minLength(6),
                        Validators.maxLength(15)
                    ]
                ],
                password: ['', [Validators.required]]
            });
        } else {
            this.form = this.fb.group({
                username: [''],
                login: [
                    this.account,
                    [
                        Validators.required,
                        Validators.pattern('^(.+@.+\..+|([0-9]{9}))$')
                    ]
                ],
                password: ['', [Validators.required]]
            });
        }
        */
        this.form = this.fb.group({
            login: [
                this.account,
                {
                    validators: [
                        Validators.required,
                        this.validateUsername
                    ],
                    updateOn: 'blur'
                }
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(32)
                ]
            ]
        });
        this.loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.infoLoading = value;
        });
        this.logged_in$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.userLoggedIn = value;
        });
        this.user_info$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.userInfo = value;
        });
        /* this.form.valueChanges.subscribe(value => {
            // this.isSubmitted = false;
        }); */
    };
    INDRALoginModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    Object.defineProperty(INDRALoginModalComponent.prototype, "login", {
        get: function () {
            return this.form.get('login');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRALoginModalComponent.prototype, "password", {
        /*
        get username() {
            return this.form.get('username');
        }
        */
        get: function () {
            return this.form.get('password');
        },
        enumerable: true,
        configurable: true
    });
    INDRALoginModalComponent.prototype.isInvalid = function (field) {
        return this.form.get(field).invalid && this.isSubmitted;
    };
    INDRALoginModalComponent.prototype.cancel = function () {
        this.store.dispatch(new UserActions.PutCancelLogIn(true));
        this.closeModal();
    };
    INDRALoginModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRALoginModalComponent.prototype.INDRA_isLoginErrorStatus = function (status) {
        switch (status) {
            case '400':
                return true;
            case '401':
                return true;
            case '404':
                return true;
            case '406':
                return true;
            case '422':
                return true;
            case '503':
                return true;
            case '500':
                return true;
            case '200':
                return false;
        }
    };
    INDRALoginModalComponent.prototype.INDRA_submitLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var login, password;
            var _this = this;
            return __generator(this, function (_a) {
                this.isSubmitted = true;
                this.loginErrorUsernameRelated = false;
                this.loginErrorPasswordRelated = false;
                this.loginErrorMessage = null;
                this.loginErrorMessageTitle = null;
                if (this.form.valid) {
                    this.store.dispatch(new UserActions.LoadingAction());
                    // Update store
                    this.userLoggedIn = true;
                    login = this.form.get('login').value;
                    password = this.form.get('password').value;
                    this.form.get('login').disable();
                    this.form.get('password').disable();
                    this.store.dispatch(new ModalActions.PutShowCloseAction(false));
                    this.authenticationService.INDRA_login(login, password).subscribe(function (response) {
                        if (_this.INDRA_isLoginErrorStatus(response.status)) {
                            _this.loginError = true;
                            if (response.errors)
                                _this.INDRA_handleLoginErrors(response.errors);
                            _this.form.get('login').enable();
                            _this.form.get('password').enable();
                            _this.store.dispatch(new UserActions.LoadingAction(false)); // explicitly stop user loader
                        }
                        else {
                            if (response.data) {
                                var _a = response.data, userProfile = _a.userProfile, userAddress = _a.userAddress, defaultCurrency = _a.defaultCurrency;
                                var userData = __assign({}, userProfile, { userAddress: userAddress, userProfile: userProfile, defaultCurrency: defaultCurrency });
                                _this.storage.set('userData', userData);
                                _this.userInfo = __assign({}, userProfile, { defaultCurrency: defaultCurrency });
                                _this.store.dispatch(new UserActions.PutLoggedInAction(_this.userLoggedIn));
                                _this.store.dispatch(new UserActions.PutUserInfoAction(_this.userInfo));
                                if (!_this.userInfo.ffLevel) {
                                    /* // commented out since club tap handling is not yet in scope or available from the API
                                    this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
                                    this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
                                    */
                                }
                                _this.closeModal();
                                if (!_this.userInfo.ffLevel && _this.isBookingPaymentPage && _this.bookedTripDiscounts.length > 0) {
                                    _this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{ source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE }]);
                                }
                            }
                            else {
                                _this.loginError = true;
                                _this.isSubmitted = false;
                                _this.form.get('login').enable();
                                _this.form.get('password').enable();
                            }
                        }
                        _this.store.dispatch(new ModalActions.PutShowCloseAction(true));
                    }, function () {
                        _this.store.dispatch(new ModalActions.PutShowCloseAction(true));
                        _this.isSubmitted = false;
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    INDRALoginModalComponent.prototype.INDRA_socialLogin = function (username, type) {
        var _this = this;
        this.isSubmitted = true;
        this.loginErrorUsernameRelated = false;
        this.loginErrorPasswordRelated = false;
        this.loginErrorMessage = null;
        this.loginErrorMessageTitle = null;
        // this.loginLoading = true;
        this.store.dispatch(new UserActions.LoadingAction());
        this.form.get('login').disable();
        this.form.get('password').disable();
        this.userLoggedIn = true;
        this.authenticationService.INDRA_SocialLogin(username, type).subscribe(function (response) {
            if (_this.INDRA_isLoginErrorStatus(response.status)) {
                _this.loginError = true;
                // this.loginLoading = false;
                if (response.errors)
                    _this.INDRA_handleLoginErrors(response.errors);
                _this.form.get('login').enable();
                _this.form.get('password').enable();
                _this.store.dispatch(new UserActions.LoadingAction(false)); // explicitly stop user loader
            }
            else {
                if (response.data) {
                    var _a = response.data, userProfile = _a.userProfile, userPnrs = _a.userPnrs, userAddress = _a.userAddress, defaultCurrency = _a.defaultCurrency;
                    // this.loginModalService.sendDataCustomer(response.data);
                    var userData = __assign({}, userProfile, { userPnrs: userPnrs, userAddress: userAddress, userProfile: userProfile, defaultCurrency: defaultCurrency });
                    _this.storage.set('userData', userData);
                    _this.userInfo = __assign({}, userProfile, { defaultCurrency: defaultCurrency });
                    _this.store.dispatch(new UserActions.PutLoggedInAction(_this.userLoggedIn));
                    _this.store.dispatch(new UserActions.PutUserInfoAction(_this.userInfo));
                    // this.store.dispatch(new UserActions.PutUserPNRSAction(userPnrs));
                    /*
                    if (this.data != null && this.data.length === 2) {
                        this.router.navigate([this.data[0]], {queryParams: this.data[1]});
                    } else if (this.data != null && this.data.length === 1) {
                        this.router.navigate([this.data[0]]);
                    } else {
                        // this.router.navigate(['./']);
                        window.location.reload();
                    }
                    */
                    _this.closeModal();
                    if (!_this.userInfo.ffLevel && _this.isBookingPaymentPage && _this.bookedTripDiscounts.length > 0) {
                        _this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{ source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE }]);
                    }
                }
                else {
                    _this.loginError = true;
                    // this.loginLoading = false;
                    _this.isSubmitted = false;
                    _this.form.get('login').enable();
                    _this.form.get('password').enable();
                }
                _this.store.dispatch(new ModalActions.PutShowCloseAction(true));
            }
        }, function (err) {
            _this.store.dispatch(new ModalActions.PutShowCloseAction(true));
            _this.isSubmitted = false;
            console.log(err);
        });
    };
    INDRALoginModalComponent.prototype.INDRA_getUserPNRs = function (tapID, ffNumber) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.authenticationService.INDRA_getUserReservations(tapID, ffNumber).subscribe(function (response) {
                if (response && response.data) {
                    _this.store.dispatch(new UserActions.PutUserPNRSAction(response.data));
                }
                resolve();
            }, function () {
                resolve();
            });
        });
    };
    INDRALoginModalComponent.prototype.validateUsername = function (c) {
        var EMAIL_REGEXP = /[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}/;
        var TAP_NUMBER_REGEX = /^\d{9}$/;
        var NUMBER_REGEX = /^\d+$/;
        if (EMAIL_REGEXP.test(c.value) || TAP_NUMBER_REGEX.test(c.value)) {
            return null;
        }
        return {
            valid: false,
            error: NUMBER_REGEX.test(c.value) ? 'tapNo' : 'email'
        };
    };
    INDRALoginModalComponent.prototype.getLoginFieldError = function () {
        if (this.login.errors) {
            switch (true) {
                case this.login.errors.required: return 'header.login.errorLoginRequiredOrInvalid';
                case this.login.errors.error === 'tapNo': return 'header.login.invalidTapNo';
                case this.login.errors.error === 'email': return 'header.login.invalidUserLogin';
            }
        }
        return '';
    };
    INDRALoginModalComponent.prototype.INDRA_handleInputChange = function (e) {
        this.form.controls[e.target.id].setValue(e.target.value.trim());
    };
    INDRALoginModalComponent.prototype.INDRA_gotoURL = function () {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var key = 'externalURLs.recoverPassword';
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageCode).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRALoginModalComponent.prototype.INDRA_serviceError = function () {
        // return true if login service error
        return this.account != '';
    };
    INDRALoginModalComponent.prototype.INDRA_errorTitle = function () {
        if (this.account != '')
            return '';
        return this.INDRA_getTranslation('header.login.text.error');
    };
    INDRALoginModalComponent.prototype.getPasswordInputType = function () {
        return this.passwordIsHidden ? 'password' : 'text';
    };
    INDRALoginModalComponent.prototype.getPasswordInputAriaLabel = function () {
        return this.passwordIsHidden ? 'Show password' : 'Hide password';
    };
    INDRALoginModalComponent.prototype.handleShowHideAnimation = function (anim) {
        this.anim = anim;
    };
    INDRALoginModalComponent.prototype.animateShowHidePassword = function () {
        if (this.passwordIsHidden) {
            this.passwordIsHidden = false;
            this.anim.setDirection(1);
            this.anim.play();
        }
        else {
            this.passwordIsHidden = true;
            this.anim.setDirection(-1);
            this.anim.play();
        }
    };
    INDRALoginModalComponent.prototype.INDRA_handleSignUp = function () {
        this.store.dispatch(new UserActions.PutCancelLogIn(true));
        this.closeModal();
        /* note: from post sprint 8 merge
        if (this.isCorporate)
            window.open('https://www.tapcorporate.com/pt-pt/adesao', '_blank');
        else
        */
        this.sidebarService.openSidebar(['sign-up']);
    };
    INDRALoginModalComponent.prototype.INDRA_handleLoginErrors = function (errorList) {
        for (var i = 0; i < errorList.length; i++) {
            if (errorList[i].code && errorList[i].desc) {
                switch (errorList[i].code) {
                    case 'FFP01.02':
                        this.loginErrorMessage = this.translatedMessagesKey.invalidStatus;
                        break;
                    case '401':
                        if (errorList[i].desc.includes(this.messages.accountLocked)) {
                            this.loginErrorMessage = this.translatedMessagesKey.accountLocked;
                            this.loginErrorMessageTitle = this.translatedMessagesTitleKey.accountLocked;
                        }
                        else if (errorList[i].desc.includes(this.messages.invalidCredentials) || (errorList[i].desc.includes(this.messages.invalidUsernameOrPassword))) {
                            // gets the number of invalid attempts provided in error message
                            this.invalidAttempts = errorList[i].desc.slice(-1);
                            this.loginErrorMessage = this.translatedMessagesKey.invalidCredentials;
                            this.loginErrorPasswordRelated = true;
                            return;
                        }
                        else if (errorList[i].desc.includes(this.messages.unauthorized)) {
                            this.loginErrorMessage = this.translatedMessagesKey.unauthorized;
                            return;
                        }
                        else {
                            this.loginErrorMessage = errorList[i].desc;
                            return;
                        }
                        break;
                    case '404':
                        this.loginErrorMessage = this.translatedMessagesKey.userUnknown;
                        this.loginErrorUsernameRelated = true;
                        return;
                    case '406':
                        this.loginErrorMessage = this.translatedMessagesKey.emailMultipleClients;
                        this.loginErrorUsernameRelated = true;
                        return;
                    case '422':
                        this.loginErrorMessage = this.translatedMessagesKey.loginServiceUnavailable;
                        this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
                        return;
                    case '503':
                        this.loginErrorMessage = this.translatedMessagesKey.loginServiceUnavailable;
                        this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
                        return;
                    case '500':
                        this.loginErrorMessage = this.translatedMessagesKey.tryLater;
                        this.loginErrorMessageTitle = this.translatedMessagesTitleKey.loginServiceUnavailable;
                        return;
                    default:
                        this.loginErrorMessage = errorList[i].desc;
                        return;
                }
            }
            else {
                this.loginErrorMessage = errorList[i].desc;
                return;
            }
        }
    };
    INDRALoginModalComponent.prototype.INDRA_getLoginErrorMessage = function () {
        if (this.loginErrorMessage) {
            return this.loginErrorMessage;
        }
        else {
            if (this.account != '') {
                return 'You can only login with the account you have used to save the original price of this booking.';
            }
            return;
        }
    };
    INDRALoginModalComponent.prototype.INDRA_recoverTP = function () {
        this.store.dispatch(new UserActions.PutCancelLogIn(true));
        return window.open(this.ibeAdminConfigService.getConfigurationValue('externalURLs.recoverTP'));
    };
    /* from post-sprint 8 client code merge
    TAP_getLabel(): string {
        return this.label;
    }
    */
    INDRALoginModalComponent.prototype.initGoogleAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pload;
            var _this = this;
            return __generator(this, function (_a) {
                pload = new Promise(function (resolve) {
                    gapi.load('auth2', resolve);
                });
                // When the first promise resolves, it means we have gapi
                // loaded and that we can call gapi.init
                return [2 /*return*/, pload.then(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, gapi.auth2
                                        .init({ client_id: SOCIAL_GOOGLE_KEY })
                                        .then(function (auth) {
                                        _this.gapiSetup = true;
                                        _this.authInstance = auth;
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    INDRALoginModalComponent.prototype.INDRA_submitGLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.gapiSetup) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initGoogleAuth()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: 
                    // Resolve or reject signin Promise
                    return [2 /*return*/, new Promise(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.authInstance.signIn().then(function (user) { return _this.user = user; }, function (error) { return _this.error = error; })];
                                    case 1:
                                        _a.sent();
                                        if (this.user && this.user.isSignedIn()) {
                                            this.INDRA_socialLogin(this.user.getId(), LOGIN_AUTENTICATION_TYPE_GOOGLE);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    INDRALoginModalComponent.prototype.checkIfUserAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.gapiSetup) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initGoogleAuth()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.authInstance.isSignedIn.get()];
                }
            });
        });
    };
    INDRALoginModalComponent.prototype.INDRA_printStyle = function (id) {
        if (id == 'password') {
            return {
                'is-filled': this.PassFilled,
                'is-focused': this.PassFocused,
                'has-error': (this.isInvalid('password') || this.loginErrorPasswordRelated) && this.isSubmitted
            };
        }
        else {
            return {
                'is-filled': this.UserFilled,
                'is-focused': this.UserFocused,
                'has-error': (this.isInvalid('login') || this.loginErrorUsernameRelated) && this.isSubmitted
            };
        }
    };
    INDRALoginModalComponent.prototype.INDRA_handleFocus = function (e) {
        if (e.target.id == 'login-password')
            this.PassFocused = true;
        else
            this.UserFocused = true;
    };
    INDRALoginModalComponent.prototype.INDRA_handleBlur = function (e) {
        if (e.target.id == 'login-password') {
            this.PassFocused = false;
            this.PassFilled = e.target.value != '';
        }
        else {
            this.UserFocused = false;
            this.UserFilled = e.target.value != '';
            this.INDRA_handleInputChange(e);
        }
    };
    INDRALoginModalComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    return INDRALoginModalComponent;
}(AbstractModalContentComponent));
export { INDRALoginModalComponent };
